import { Drawer, styled } from '@mui/material'

const RoundedDrawer = styled(Drawer)(({ theme }) => ({
  '.MuiPaper-root': {
    borderTopRightRadius: theme.shape.borderRadius,
    borderTopLeftRadius: theme.shape.borderRadius
  }
}))

export default RoundedDrawer